<div class="w-full mx-auto p-6 rounded-lg">
  <h2 class="titre2">
    {{ (data.mode === 'add' ? 'USERS_MANAGEMENT.ADD_TAGS' : 'USERS_MANAGEMENT.REMOVE_TAGS') | translate }}
  </h2>

  <div class="mb-4 mt-2">
    <span class="block text-sm font-medium mb-1">{{ 'USERS_MANAGEMENT.TAGS' | translate }}</span>
    <select title="etiquettes" #etiquetteSelect (change)="onEtiquetteSelected($event, etiquetteSelect)"
      class="w-full p-2 border rounded">
      <option value="">{{ 'USERS_MANAGEMENT.SELECT_TAG' | translate }}</option>
      @for (etiquette of availableEtiquettes; track etiquette) {
        <option [value]="etiquette.etiquetteId">
          {{ etiquetteService.getNomLocalise(etiquette.locales) }}
        </option>
      }
    </select>

    @if (selectedEtiquettes.length > 0) {
      <div class="mt-3">
        <h4 class="titre4">{{ 'USERS_MANAGEMENT.SELECTED_TAGS' | translate }}:</h4>
        <ul class="list-disc list-inside">
          @for (etiquette of selectedEtiquettes; track etiquette) {
            <li>
              {{ etiquetteService.getNomLocalise(etiquette.locales) }}
              <button (click)="removeSelectedEtiquette(etiquette.etiquetteId)" class="ml-2 text-rougeNovo">
                {{ 'USERS_MANAGEMENT.REMOVE' | translate }}
              </button>
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <div class="flex justify-end mt-4">
    <button (click)="onCancel()" type="button" class="mr-2 px-4 py-2 btn-secondary-novo">
      {{ 'USERS_MANAGEMENT.CANCEL' | translate }}
    </button>
    <button (click)="onConfirm()" type="submit" class="px-4 py-2 btn-primary-novo" [disabled]="selectedEtiquettes.length === 0">
      {{ (data.mode === 'add' ? 'USERS_MANAGEMENT.ADD' : 'USERS_MANAGEMENT.REMOVE') | translate }}
    </button>
  </div>
</div>